import { format, isSameYear, UTCDate } from '@/utils/dates';
import { TransactionView } from '../../../types/entity-types';

export type TransactionDisplayInfo = {
  name: string;
  avatarUrl?: string;
  initials: string;
};

export const getTransactionDisplayInfo = (transaction: TransactionView): TransactionDisplayInfo => {
  if (transaction.vendor?.name) {
    return {
      name: transaction.vendor.name,
      avatarUrl: transaction.vendor.logo ?? undefined,
      initials: getMerchantInitials(transaction.vendor.name),
    };
  }

  const merchantName = transaction.merchantName ?? transaction.description;

  return {
    name: merchantName,
    avatarUrl: undefined,
    initials: getMerchantInitials(merchantName),
  };
};

export const getMerchantInitials = (name: string): string => {
  const trimmedName = name.trim();

  if (!trimmedName) {
    return '?';
  }

  const parts = trimmedName.split(/[\s-]+/).filter(Boolean);

  if (parts.length === 0) {
    return '?';
  }

  if (parts.length === 1) {
    return parts[0][0].toUpperCase();
  }

  return `${parts[0][0].toUpperCase()}${parts[1][0].toUpperCase()}`;
};

export const formatTransactionDate = (fspDate: Date | string): string => {
  const date = new UTCDate(fspDate);
  const currentYear = new UTCDate();
  const dateFormat = isSameYear(date, currentYear) ? 'd MMM' : 'd MMM yyyy';

  return format(date, dateFormat);
};

export const truncateAfterSecondWord = (name: string): string => {
  const trimmedName = name.trim();

  if (!trimmedName) {
    return trimmedName;
  }

  const parts = trimmedName.split(/([\s-]+)/);
  const words: string[] = [];
  const delimiters: string[] = [];

  for (let i = 0; i < parts.length; i++) {
    if (i % 2 === 0) {
      if (parts[i]) {
        words.push(parts[i]);
      }
    } else {
      delimiters.push(parts[i]);
    }
  }

  if (words.length <= 2) {
    return trimmedName;
  }

  const firstTwoWords = words[0] + (delimiters[0] || '') + words[1];

  return `${firstTwoWords}...`;
};
